import { Component, OnInit, ViewEncapsulation, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

import { Uploader } from './uploader';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class UploaderComponent extends Uploader implements OnInit {
  @HostBinding('attr.status') attrStatus;
  @Input() overrideName = '';
  @Input() autoUpload = true;
  @Input() files;
  @Input() maxFiles;
  @Input() maxRes;
  @Input() minRes;
  @Input() exactRes;
  @Input() maxSize;
  @Input() fileTypes;
  @Input() allowDuplicates;
  @Input() status;
  @Input() storagePath;

  @Output() fileUploaded = new EventEmitter<any>();
  @Output() fileDeleted = new EventEmitter<any>();
  @Output() fileAdded = new EventEmitter<any>();
  @Output() statusChanged = new EventEmitter<any>();

  droppedFiles = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.statusChanged.subscribe((status: Uploader.UploadStatus) => this.attrStatus = status);
    this.fileAdded.subscribe((file: Uploader.FileItem) => {
      if (this.overrideName) {
        file.name = this.overrideName;
      }
      if (this.autoUpload) {
        this.uploadFile(file);
      }
    });
  }

  setStatus(status) {
    this.attrStatus = status;
  }

}
